export class Cell {
  userEnteredValue: object;
  userEnteredFormat: object;
  constructor(userEnteredValue: object, userEnteredFormat: object) {
    this.userEnteredValue = userEnteredValue;
    this.userEnteredFormat = userEnteredFormat;
  }
}
